import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ZButton from "@/components/ZButton";
import Logo from "@/components/Logo";
import { ArrowRight } from "lucide-react";

const SLIDES = [
  {
    title: "Bienvenue dans votre espace organisateur 👋",
    text: "Créez vos événements, vendez vos billets et gérez vos accès depuis un seul endroit.",
  },
  {
    title: "Inviter des agents pour scanner les billets",
    text: "Vous pouvez désigner des agents pour contrôler les entrées de chaque événement.",
  },
  {
    title: "Engagez votre communauté",
    text: "Lancez cagnottes, votes et sondages pour faire participer vos invités.",
  },
];

export default function OnboardingOrganizerPage() {
  const { refreshUser } = useAuth();
  const nav = useNavigate();
  const [idx, setIdx] = useState(0);
  const [loading, setLoading] = useState(false);

  const finish = async () => {
    setLoading(true);
    try {
      await api.post("/auth/complete-onboarding");
      await refreshUser();
      nav("/org");
    } finally {
      setLoading(false);
    }
  };

  const next = () => {
    if (idx < SLIDES.length - 1) setIdx(idx + 1);
    else finish();
  };

  return (
    <div className="z-container" style={{ maxWidth: 520 }} data-testid="onboarding-page">
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 4 }}>
        <button
          onClick={finish}
          disabled={loading}
          data-testid="onboarding-skip-top-btn"
          style={{
            display: "inline-flex", alignItems: "center", gap: 6,
            background: "transparent", border: 0, cursor: "pointer",
            color: "var(--z-teal)", fontWeight: 600, fontSize: 14, padding: "6px 4px",
          }}
        >
          Passer l&apos;introduction <ArrowRight size={15} />
        </button>
      </div>
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <Logo to={null} size={28} />
      </div>

      <div className="z-card" style={{ padding: 32, textAlign: "center", minHeight: 320, display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", gap: 6, marginBottom: 24 }}>
          {SLIDES.map((_, i) => (
            <span key={i} style={{
              width: i === idx ? 24 : 8, height: 8, borderRadius: 999,
              background: i === idx ? "var(--z-teal)" : "var(--z-border)",
              transition: "all 0.2s ease",
            }} />
          ))}
        </div>
        <h2 className="z-modal-title" style={{ marginBottom: 14 }} data-testid="onboarding-title">{SLIDES[idx].title}</h2>
        <p style={{ color: "var(--z-muted)", fontSize: 15, lineHeight: 1.6 }}>{SLIDES[idx].text}</p>

        <div style={{ display: "flex", gap: 10, justifyContent: "space-between", alignItems: "center", marginTop: 30 }}>
          <button onClick={finish} className="z-link" style={{ background: "transparent", border: 0, fontSize: 14 }} data-testid="onboarding-skip-btn">
            Passer
          </button>
          <ZButton onClick={next} loading={loading} data-testid="onboarding-next-btn">
            {idx === SLIDES.length - 1 ? "C'est parti !" : "Suivant"}
          </ZButton>
        </div>
      </div>
    </div>
  );
}
